"use strict";
var BoundCallbackObservable_1 = require('./BoundCallbackObservable');
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/observable/bindCallback.js
// module id = ./node_modules/rxjs/observable/bindCallback.js
// module chunks = 0